import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { LinkField } from '@prismicio/client';
import { BrandService } from 'brand';
import { SvgComponent } from 'icon';
import { LinkComponent } from 'link';
import { LanguageSelectorComponent } from 'menu';
import { TranslatePipe } from 'translate';
import { FooterBottomLinksAreaSlice } from '../footer.class';

@Component({
  selector: 'lib-footer-bottom-links-area',
  templateUrl: './footer-bottom-links-area.component.html',
  imports: [LanguageSelectorComponent, LinkComponent, SvgComponent, TranslatePipe, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterBottomLinksAreaComponent {
  @Input() public slice: FooterBottomLinksAreaSlice;
  public goToHomeLink = <LinkField>{ link_type: 'Document', slug: '' };
  public brandService = inject(BrandService);
}
